import { Component, Input, OnInit, EventEmitter, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ComponenteCameraComponent } from './componente-camera.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DominiosService } from '../../services/dominios.service';
import { UrlService } from '../../services/url.service';
import { UrlControl } from '../../models/generic.model';
import { AppSettings } from 'src/app/app.settings';
import { GlobalService } from '../../global.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { AlertService } from '../../services/alert.service';
import { query } from '@angular/core/src/render3';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'informacion-visitante',
  templateUrl: './informacion-visitante.component.html',
  styleUrls: ['./informacion-visitante.component.scss']
})
export class InformacionVisitanteComponent implements OnInit, OnChanges {

  public urlFoto: string;
  public botonEditar = false;
  public botonCaptura = true;
  public foto = true;
  public OcultarFoto = false;
  public check: boolean = null;
  private listaDominios = [DominiosService.TIPO_VEHICULO];
  public dominios: DetalleDominio[];
  public tipoVehiculo;
  public listaVehiculos;

  // tslint:disable-next-line: no-input-rename
  @Input('objeto') informacionVisitante: any;
  @Output() resultado = new EventEmitter();


  constructor(
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private urlService: UrlService,
    private global: GlobalService,
    private alertService: AlertService
    ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.informacionVisitante.ingresoVehiculo) {
      this.check = true;
    } else {
      this.check = false;
    }
    if (this.check != null) {
      this.changeCheck(this.check);
    }

  }

  ngOnInit() {
    this.consultarDominios();
  }

  changeCheck(event) {
    const c1: any = document.getElementById('checkVehicul01');
    const c2: any = document.getElementById('checkVehicul02');
    this.check = event;
    if (c1 && c2) {
      if (event) {
        c1.checked = true;
        c2.checked = false;
      } else {
        c1.checked = false;
        c2.checked = true;
      }
      this.informacionVisitante.ingresoVehiculo = this.check;
      this.emitModelo();
    }
  }
  emitModelo() {
    this.resultado.emit(this.informacionVisitante);
  }

  vermodalacamara() {
    const modalRef = this.modalService.open(ComponenteCameraComponent, { centered: false, size: 'lg' });
    modalRef.result.then((result) => {
      this.urlFoto = result.imageAsDataUrl.imageAsDataUrl;

      this.informacionVisitante.foto = this.urlFoto;


      this.actualizarPantalla();
      this.convertirUrlImageToDateImage(result.imageBase64);

    });
  }

  actualizarPantalla() {
    this.botonCaptura = false;
    this.botonEditar = true;
    this.OcultarFoto = true;
  }

  convertirUrlImageToDateImage(image: any) {
    const imageName = 'imagen.jpeg';
    // call method that creates a blob from dataUri
    const imageBlob = this.dataURItoBlob(image);
    const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });


    this.emitModelo();

  }

  dataURItoBlob(dataURI): Blob {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  public consultarDominios() {
    this.spinner.show();
    const serviceProvider = 'consultarDominios';
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), AppSettings.API_INIT_ENDPOINT);
    this.global.postGenerico(url, this.listaDominios).subscribe(
        data => {
            this.dominios = data;
            this.spinner.hide();
        }, (err: any) => {
            this.catchException('Ocurrio un error en la consulta de los dominios');
        }
    );
  }

  public filtrarDominios() {
    let tipo = '';
    if (this.tipoVehiculo) {
      tipo = this.tipoVehiculo.valor;
    } else if (this.dominios) {
      this.tipoVehiculo = this.dominios.find(dominio =>
        dominio.detalleDominioPK.nombreDetalleDominio === this.informacionVisitante.vehiculo);
      tipo = this.tipoVehiculo ? this.tipoVehiculo.valor : '';
    }
    return tipo;
  }

  /**
   * Método de control de Excepciones
   * @param error mensaje saliente respecto al error ocurrido
   */
  catchException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }
}
